var packageName = 'polyglot';
export var SET_LOCALE = "".concat(packageName, "/SET_LOCALE");
export var SET_DEFAULT_PHRASES = "".concat(packageName, "/SET_DEFAULT_PHRASES");
export var FETCH_PHRASES = "".concat(packageName, "/FETCH_PHRASES");
export var FETCH_PHRASES_SUCCESS = "".concat(packageName, "/FETCH_PHRASES_SUCCESS");
export var FETCH_PHRASES_FAIL = "".concat(packageName, "/FETCH_PHRASES_FAIL");